(function () {
  /**
   * @ngdoc module
   * @name app.core.api
   * @description module that defines api resource services
   */
  angular.module('app.core.api', [
    'app.core.api.interceptor',
    'app.core.api.interceptor.ready',
    'app.core.api.jil',
  ]);
})();
